import React, { Component } from 'react'
//import all child components
import Container from '../../components/Container'
import Title from '../../components/Title'
import CompanyInfo from '../Form/AboutInfo'
import ContactForm from '../Form/AboutData'



const About = () => {
        return (
            <Container>
                <Container wrapper>
                    <CompanyInfo />
                    <ContactForm />
                </Container>
            </Container>
        );
    }


export default About